import { useState, useEffect } from 'react';

import queryString from 'query-string';

import useDebounce from './useDebounce';

export default function useFilter({ key, value, delay, location }) {
  const [filter, setFilter] = useState(value);
  const [filterValue, setFilterValue] = useState(filter);

  const debounceFilter = useDebounce(value, delay);

  useEffect(() => setFilter(value), [value]);

  useEffect(() => {
    const queryParams = queryString.parse(window.location.hash.split('?')[1]);
    delete queryParams[key];

    if (value !== filterValue) {
      delete queryParams.page;
    }

    const hasParams = !!Object.keys(queryParams).length;
    const params = hasParams ? `?${queryString.stringify(queryParams)}` : '';

    const queryFilter =
      filter && filter !== '' && filter !== null
        ? `${hasParams ? '&' : '?'}${key}=${filter}`
        : '';

    const url = `/#${location.pathname}${params}${queryFilter}`;
    window.history.pushState({ path: url }, '', url);

    setFilterValue(filter);
  }, [debounceFilter]);

  return filterValue;
}



// WEBPACK FOOTER //
// ./src/hooks/useFilter.js